import { render } from "./BookingCompleted.vue?vue&type=template&id=71f772e1&scoped=true"
import script from "./BookingCompleted.vue?vue&type=script&lang=js"
export * from "./BookingCompleted.vue?vue&type=script&lang=js"

import "./BookingCompleted.vue?vue&type=style&index=0&id=71f772e1&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f772e1"]])

export default __exports__